import { useState } from 'react'
import axios, { pluckData } from 'src/utilities/http-client'
import { downloadFile } from 'src/v3/utilities/filesystem'
import { CertificateRollupItem } from '../types'

let getCertificate = (id: string, type: string) =>
  axios
    .get(
      `/api/v2/profile/certificate/export?certificateID=${id}&certificateType=${type}`,
    )
    .then(pluckData)

export function useCertificateDownload() {
  let [downloadingCerts, setDownloadingCerts] = useState<Set<string>>(new Set())

  let downloadCertificate = async (
    item: CertificateRollupItem,
  ): Promise<{ success: boolean; error?: string }> => {
    if (!item.certificateID)
      return { success: false, error: 'No certificate ID' }

    let certID = item.certificateID
    setDownloadingCerts((prev) => new Set(prev).add(certID))

    try {
      let certificateType =
        item.type === 'live'
          ? 'live'
          : item.type === 'external'
            ? 'external'
            : 'recorded'
      let response = await getCertificate(certID, certificateType)
      let fileResponse = await axios.get(response, { responseType: 'blob' })

      let extension =
        item.type === 'external'
          ? fileResponse.data.type === 'image/png'
            ? 'png'
            : fileResponse.data.type === 'image/jpeg'
              ? 'jpeg'
              : 'pdf'
          : 'pdf'

      let filename = `${item.courseActivity.replace(/\s+/g, '_')}_${certID}.${extension}`

      await downloadFile(fileResponse.data, filename)
      return { success: true }
    } catch (err: any) {
      return {
        success: false,
        error: `Certificate download failed: ${err?.message || 'Unknown error'}`,
      }
    } finally {
      setDownloadingCerts((prev) => {
        let newSet = new Set(prev)
        newSet.delete(certID)
        return newSet
      })
    }
  }

  let isDownloading = (certificateID: string | null) =>
    certificateID ? downloadingCerts.has(certificateID) : false

  return {
    downloadCertificate,
    isDownloading,
  }
}
